import { render, staticRenderFns } from "./PostRequest.vue?vue&type=template&id=313c8328&scoped=true"
import script from "./PostRequest.vue?vue&type=script&lang=js"
export * from "./PostRequest.vue?vue&type=script&lang=js"
import style0 from "./PostRequest.vue?vue&type=style&index=0&id=313c8328&prod&lang=css"
import style1 from "./PostRequest.vue?vue&type=style&index=1&id=313c8328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313c8328",
  null
  
)

export default component.exports